module.exports = __webpack_public_path__ + "static/media/E-House Monitoring.952124e0.png";